import styled from 'styled-components'
import { mediaQueries } from '@blazar-plugins/device'

export const CarouselWrapper = styled.div.attrs(({ shouldHavePadding }) => ({
  paddingBottom: shouldHavePadding ? '20px' : '0px',
}))`
  padding-bottom: ${(props) => props.paddingBottom};
`

export const ButtonContainer = styled.div`
  display: flex;
  z-index: 1;
  justify-content: space-between;
  color: #696766;
  font-size: 15px;
`

export const PreviousContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`

export const NextContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const StyledButton = styled.button`
  cursor: pointer;
  position: relative;
`

export const Separator = styled.div`
  border-bottom: 0.5px solid rgb(225, 225, 225);
  margin: 0 16px;
  height: 1px;

  @media ${mediaQueries.medium} {
    border-bottom: 0px;
  }
`
